<template>
  <div class="rh-footer-main">
    <div class="container">
      <div class="footer-top_wrap">
        <div class="left">
          <div class="left-top">
            <div class="img">
              <img src="https://static.rhkj.com/renhe_fe/other/learning/rhlogo.png">
            </div>
            <div class="about">
              <h2><span>咨询热线：</span><span>400-8899-059</span></h2>
            </div>
          </div>
          <div class="footer-nav">
            <p><a href="/">首页</a></p>
            <p><a href="/main/allCourse">选课中心</a></p>
            <p><a href="/learning/questionBank">题库</a></p>
            <p><a href="/live">直播</a></p>
            <p><a href="/class">公开课</a></p>
            <p><a href="/web/about">关于我们</a></p>
            <p><a href="https://static.rhkj.com/h5/index.html#/info/agreement">用户协议</a></p>
            <p><a href="https://static.rhkj.com/h5/index.html#/info/policy">隐私政策</a></p>
          </div>
        </div>
        <div class="weixin">
          <div>
            <span><img src="https://renhe-platform-prod.oss-cn-shanghai.aliyuncs.com/2026-03-20/1773970522549_qrcode_whrhkjcom_1.jpg"></span>
            <p>官方微信号</p>
          </div>
        </div>
      </div>
      <p class="licence" style="margin-bottom: 10px;"><a href="/web/licence">广播电视节目制作经营许可证</a></p>
      <p style="color:#70717d;text-align:center;margin-bottom: 10px;">网站宣传内容为武汉荣昌仁和会计咨询服务有限公司</p>
      <div class="footer-bottom_wrap">
        <p>
          <a href="https://beian.miit.gov.cn/"
            target="_blank">沪ICP备2020032999号-1</a>&nbsp;&nbsp;&nbsp;版权所有©2030&nbsp;&nbsp;上海财略文化传播有限公司
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped lang="scss">
.rh-footer-main {
  background-color: #0f0f1e;
  padding: 32px 0 15px;

  .container {
    width: 1200px;
    box-sizing: border-box;
    padding: 0 15px;
    margin: 0 auto;


    .footer-top_wrap {
      display: flex;
      justify-content: space-between;
      margin-bottom: 45px
    }

    .footer-top_wrap>.left {
      padding: 13px 0 15px;
      flex: 1;
      border-right: 1px solid rgba(255, 255, 255, .49)
    }

    .footer-top_wrap>.left>.left-top {
      display: flex
    }

    .footer-top_wrap>.left>.left-top>.img {
      width: 199px;
      height: 45px
    }

    .footer-top_wrap>.left>.left-top>.about {
      margin-left: 30px
    }

    .footer-top_wrap>.left>.left-top>.about>h2 {
      font-size: 24px;
      color: #fff;
      line-height: 33px;
      margin: 0 0 10px;
      font-weight: normal
    }

    .footer-top_wrap>.left>.left-top>.about>h2>span:nth-child(2) {
      font-size: 40px;
      font-weight: normal;
      color: #fff;
      line-height: 45px;
      font-style: italic
    }

    .footer-top_wrap>.left>.footer-nav {
      display: flex;
      margin-top: 30px
    }

    .footer-top_wrap>.left>.footer-nav>p {
      padding: 0 30px;
      line-height: 14px;
      border-right: 1px solid #fff
    }

    .footer-top_wrap>.left>.footer-nav>p:first-child {
      padding-left: 0
    }

    .footer-top_wrap>.left>.footer-nav>p:last-child {
      border: 0
    }

    .footer-top_wrap>.left>.footer-nav>p>a {
      font-size: 14px;
      color: #fff
    }

    .footer-top_wrap>.left>.left-top>.img>img {
      width: 100%;
      height: 100%;
      display: block
    }

    .footer-top_wrap>.weixin {
      padding-left: 100px;
      display: flex;
      color: #70717d;
      font-size: 12px;
      text-align: center
    }

    .footer-top_wrap>.weixin>div {
      margin-left: 20px
    }

    .footer-top_wrap>.weixin p {
      margin-top: 8px;
      line-height: 17px;
      color: #fff
    }

    .footer-top_wrap>.weixin img {
      width: 108px;
      height: 108px
    }

    .licence {
      text-align: center;
      margin-bottom: 20px
    }

    .licence a {
      color: #70717d
    }

    .footer-bottom_wrap {
      text-align: center;
      color: #70717d
    }

    .footer-bottom_wrap p a {
      color: #70717d
    }

    .footer-bottom_wrap>ul {
      display: flex;
      justify-content: center
    }

    .footer-bottom_wrap>ul>li {
      padding: 0 10px;
      line-height: 18px;
      border-left: 1px solid #70717d
    }

    .footer-bottom_wrap>ul>li:nth-child(1) {
      border-left: 0
    }

    .footer-bottom_wrap>ul>li>i {
      width: 20px;
      margin-right: 8px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
      background-size: 100% 100%
    }

    .footer-bottom_wrap>ul>li:nth-child(1)>i {
      background: url("../img/renhe/copyright.png") round
    }

    .footer-bottom_wrap>ul>li:nth-child(2)>i {
      background: url("../img/renhe/govIcon.png") round
    }

    .footer-bottom_wrap>ul>li>span {
      display: inline-block;
      vertical-align: middle
    }

    .footer-course-list_wrap {
      text-align: center
    }

    .footer-course-list_wrap>.footer-nav>span {
      display: inline-block;
      color: #70717d;
      font-size: 12px
    }

    .footer-course-list_wrap>.footer-nav>span>a {
      color: #70717d;
      display: inline-block;
      padding: 0 10px;
      border-right: 1px solid #70717d;
      line-height: 12px
    }

    .footer-course-list_wrap>.footer-nav>span:nth-child(4)>a {
      border: 0
    }

    .footer-course-list {
      padding: 20px 0
    }

    .licence-main-box {
      height: 950px;
      text-align: center
    }

    .licence-main-box img {
      margin: 58px auto
    }
  }
}
</style>
